/**
 * Deployment base path — single source of truth.
 *
 * `__BASE_PATH__` is injected at build time by vite.config.ts (define) and is
 * ALWAYS defined in the Readdy build, so behavior there is byte-for-byte
 * unchanged. A new host may build without injecting it; the `typeof` guard
 * below then falls back to the root path "/" instead of throwing a
 * `ReferenceError`. Every place that needs the base path imports from here, so
 * the safe fallback can never be forgotten at a call site.
 */

// Raw injected value, with a safe default for builds that do not define it.
// The `typeof` check is required because referencing an undeclared global would
// throw before any `||` fallback could run.
const RAW_BASE_PATH: string =
  typeof __BASE_PATH__ !== 'undefined' && __BASE_PATH__ ? __BASE_PATH__ : '/';

/**
 * Base path WITHOUT a trailing slash:
 *   ''        when served at the root (base "/")
 *   '/prefix' when served under a sub-path
 */
export const BASE_PATH = RAW_BASE_PATH.replace(/\/+$/, '');

/**
 * Base path usable as a URL prefix:
 *   '/'       at the root
 *   '/prefix' under a sub-path
 */
export const BASE_PATH_PREFIX = BASE_PATH || '/';

export default BASE_PATH;